import type { Id } from '@e-socna/data-layer';

import type { FolderBusinessEntityStateFormValues } from '../../FolderBusinessEntityState/types/values.type';

type QuotationStateFormValues = FolderBusinessEntityStateFormValues &
  Readonly<{ selectedOptionGroupIds?: readonly Id[] }>;

// The back rejects a client choice of the options on an action that does not
// ask for it, even when the field was filled for another action.
export const buildQuotationStateUpdateValues = (
  values: QuotationStateFormValues,
  isOptionGroupsSelectionAction: (actionId: Id) => boolean,
) => {
  const { selectedOptionGroupIds, ...otherValues } = values;

  return isOptionGroupsSelectionAction(values.actionId)
    ? { ...otherValues, selectedOptionGroupIds: selectedOptionGroupIds ?? [] }
    : otherValues;
};
